<!-- @format -->

<gauge>
  <style>
    svg {
      width: 100%;
      height: 100%;
      margin: auto;
      background: rgb(0, 0, 0, 0);
      display: block;
      shape-rendering: auto;
      font-family: Montserrat, sans-serif;
      font-weight: bold;
    }
  </style>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="{ state.size*2 }"
    height="{ state.size }"
    viewBox="{ -state.size } { -state.size } { state.size*2 } { state.size }"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      r="{ state.radius }"
      cx="0%"
      cy="0%"
      stroke="#D3D3D3"
      stroke-width="{ state.meterWidth }"
      stroke-dasharray="{ state.dasharray } { state.dasharray }"
      fill="none"
      transform="rotate(180)"
    ></circle>
    <circle
      if="{!isNaN(state.meter)}"
      r="{ state.radius }"
      cx="0%"
      cy="0%"
      stroke="{ state.fill }"
      stroke-width="{ state.meterWidth }"
      stroke-dasharray="{ state.dasharray*(state.meter/100) } { state.dasharray*2 }"
      fill="none"
      transform="rotate(180)"
    >
    </circle>

    <text
      if="{ props.enableText && !isNaN(state.meter) }"
      style="font-size: { state.size*0.60 }px;"
      x="2%"
      y="0%"
      dominant-baseline="baseline"
      text-anchor="middle"
      fill="{ state.fill }"
    >
      { state.meter }
      <tspan style="font-size: { state.size*0.2 }px;" dx="{ -state.size*0.15 }">
        %
      </tspan>
    </text>
  </svg>

  <script>
    import { getLevel } from "@model/utils.js";
    import * as d3 from "d3";

    export default {
      onBeforeMount(props, state) {
        this.updateState(props, state);
      },
      onBeforeUpdate(oldProps, newProps) {
        this.updateState(this.props, this.state);
      },
      updateState(props, state) {
        state.size = Number(props.size);
        state.meter = Number(props.meter);
        if (!state.size) {
          state.size = 20;
        }
        state.radius = state.size * 0.84;
        state.meterWidth = state.size * 0.32;
        state.dasharray = 3.14 * state.radius;
        state.fill = ["", "#7AB6D6", "#EAB027", "#F96D87"][
          getLevel(state.meter, "ratio")
        ];

        if (props.interpolate) {
          const color = d3
            .scaleSequential((t) => {
              return t < 0.5
                ? d3.interpolate("#7AB6D6", "#EAB027")(t / 0.5)
                : d3.interpolate("#EAB027", "#F96D87")((t - 0.5) / 0.5);
            })
            .domain([0, 100]);
          state.fill = color(state.meter);
        }
      },
    };
  </script>
</gauge>
